import { createNumberMask } from 'text-mask-addons';

export const currencyMask = (options = {}) =>
  createNumberMask({
    prefix: '$',
    allowDecimal: true,
    ...options
  });
